// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3CX83","description":"PatientConsentPreview_description__Y6ueF"};